import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HelcimPayScriptLoaderService {
  private loadingPromise: Promise<void> | null = null;

  load(): Promise<void> {
    if (!environment.helcimPay.enabled) {
      return Promise.reject(new Error('HelcimPay is disabled in the current environment.'));
    }

    if (typeof document === 'undefined') {
      return Promise.reject(new Error('Document is not available for HelcimPay script loading.'));
    }

    const globalWindow = window as Window & {
      appendHelcimPayIframe?: (checkoutToken: string) => void;
    };

    if (typeof globalWindow.appendHelcimPayIframe === 'function') {
      return Promise.resolve();
    }

    const existingScript = document.querySelector<HTMLScriptElement>('script[data-helcimpay="true"]');
    if (existingScript && typeof globalWindow.appendHelcimPayIframe === 'function') {
      return Promise.resolve();
    }

    if (this.loadingPromise) {
      return this.loadingPromise;
    }

    this.loadingPromise = new Promise<void>((resolve, reject) => {
      const script = existingScript ?? document.createElement('script');

      script.src = environment.helcimPay.scriptUrl;
      script.async = true;
      script.defer = true;
      script.setAttribute('data-helcimpay', 'true');

      script.onload = () => {
        this.loadingPromise = null;
        resolve();
      };

      script.onerror = () => {
        this.loadingPromise = null;
        reject(new Error('Failed to load HelcimPay script.'));
      };

      if (!existingScript) {
        document.body.appendChild(script);
      }
    });

    return this.loadingPromise;
  }
}
